import React, { useState, useContext } from 'react';

import { MemberDB } from 'api/members';
import { Button, Modal, Row, Col, ModalHeader, InputGroup, Input, InputGroupText, Form } from 'reactstrap';
import { FaSearch, FaSpinner } from 'react-icons/fa';

import UserContext from '../../UserContext';
import { member } from '../../../api';

interface Props {
	isOpen: boolean;
	handleCloseClick: () => void;
	handleMemberSelectClick: (member: MemberDB) => void;
}

export const GuestDocumentMemberSearch = (props: Props) => {
	const { isOpen: modalOpen, handleCloseClick, handleMemberSelectClick } = props;
	const { jwt } = useContext(UserContext);
	const [isSearchInProgress, setIsSearchInProgress] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const [searchResults, setSearchResults] = useState<MemberDB[]>([]);

	async function handleSearchFormAction(e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLElement, MouseEvent>) {
		e.preventDefault();

		if (isSearchInProgress || searchQuery.length === 0) {
			return;
		}

		setIsSearchInProgress(true);

		try {
			const results = await member.search(jwt, searchQuery);

			setSearchResults(results);
			setIsSearchInProgress(false);
		} catch (error) {
			setIsSearchInProgress(false);
		}
	}

	return (
		<Modal
			className="modal-lg guest-document-member-search-overlay"
			isOpen={modalOpen}
			toggle={() => {
				setSearchQuery('');
				setSearchResults([]);
				handleCloseClick();
			}}
		>
			<ModalHeader
				toggle={() => {
					setSearchQuery('');
					setSearchResults([]);
					handleCloseClick();
				}}
			>
				Member Search
			</ModalHeader>
			<div className="modal-body">
				<Row>
					<Col sm="5">
						<Form onSubmit={(e) => handleSearchFormAction(e)}>
							<InputGroup>
								<Input
									type="text"
									placeholder="Search for existing Member"
									data-lpignore="true"
									onChange={(e) => setSearchQuery(e.target.value)}
									disabled={isSearchInProgress}
									value={searchQuery}
								/>
								<InputGroupText onClick={(e) => handleSearchFormAction(e)}>
									{!isSearchInProgress ? <FaSearch /> : <FaSpinner size={12} className="fa-spin" />}
								</InputGroupText>
							</InputGroup>
						</Form>
					</Col>
				</Row>

				{searchResults.length > 0 ? (
					<>
						<Row>
							<Col>
								<h4>Results</h4>
							</Col>
						</Row>

						{searchResults.map((member) => (
							<Row>
								<Col style={{ display: 'flex', alignItems: 'center' }}>
									<div>
										{member['first-name']} {member['last-name']} ({member['bsa-id']})
									</div>
								</Col>
								<Col>
									<Button
										color="secondary"
										size="sm"
										onClick={() => {
											setSearchQuery('');
											setSearchResults([]);
											handleMemberSelectClick(member);
										}}
									>
										Select
									</Button>
								</Col>
							</Row>
						))}
					</>
				) : (
					<></>
				)}
			</div>
		</Modal>
	);
};
